import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';

export default function ServiceModal({ visible, onClose, onSubmit, service }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type_service: '',
  });
  const modalRef = useRef();

  // Met à jour le formulaire à chaque service modifié
  useEffect(() => {
    if (service) {
      setFormData({
        name: service.name || '',
        description: service.description || '',
        type_service: service.type_service || '',
      });
    } else {
      setFormData({ name: '', description: '', type_service: '' });
    }
  }, [service]);

  // Fermer si clic hors modal
  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden'; // Bloque scroll page quand modal ouvert
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [visible]);

  if (!visible) return null;

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.type_service.trim()) {
      toast.error('Le nom et le type de service sont requis.');
      return;
    }
    onSubmit(formData);
  };

  return (
    <div
      aria-modal="true"
      role="dialog"
      aria-labelledby="modal-title"
      tabIndex={-1}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm animate-fadeIn"
    >
      <form
        ref={modalRef}
        onSubmit={handleSubmit}
        className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg animate-slideDown"
      >
        <h2 id="modal-title" className="text-xl font-semibold mb-4">
          {service ? 'Modifier' : 'Ajouter'} un service
        </h2>

        <label htmlFor="name" className="block font-medium mb-1">
          Nom <span className="text-red-500">*</span>
        </label>
        <input
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full mb-4 border rounded px-3 py-2 focus:outline-blue-500"
          placeholder="Nom du service"
          autoFocus
          required
        />

        <label htmlFor="description" className="block font-medium mb-1">
          Description
        </label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full mb-4 border rounded px-3 py-2 focus:outline-blue-500"
          placeholder="Description"
          rows={3}
        />

        <label htmlFor="type_service" className="block font-medium mb-1">
          Type de service <span className="text-red-500">*</span>
        </label>
        <select
          id="type_service"
          name="type_service"
          value={formData.type_service}
          onChange={handleChange}
          className="w-full mb-6 border rounded px-3 py-2 focus:outline-blue-500"
          required
        >
          <option value="">-- Choisir --</option>
          <option value="IT">IT</option>
          <option value="Marketing">Marketing</option>
          <option value="Support">Support</option>
          <option value="RH">RH</option>
        </select>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded border border-gray-400 hover:bg-gray-100"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {service ? 'Modifier' : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
  );
}
